// extracted by mini-css-extract-plugin
export var deliveryRow = "_pj-a";
export var fixedHeight = "_pj-4";
export var freightLogo = "_pj-9";
export var fullWidth = "_pj-3";
export var priceColumn = "_pj-5";
export var radioSelected = "_pj-7";
export var radioUnselected = "_pj-6";
export var selectedOption = "_pj-2";
export var selectedOptionContainer = "_pj-1";
export var selection = "_pj-0";
export var tallSkeletonText = "_pj-8";